export default __webpack_public_path__ + "static/media/default.284f37a8.jpg";